import { saPushEvent } from "@spot-fe/utils";

export const evt = 'PreMarket';

export const tradeRuleClick = () => {
  saPushEvent(evt, {
    page_name: 'TradeRule_page',
    page_area: 'TradeRule_enter',
    button_name: 'TradeRule',
  });
}

export const faqClick = () => {
  saPushEvent(evt, {
    page_name: 'FAQ_page',
    page_area: 'FAQ_enter',
    button_name: 'FAQ',
  });
}

export const userGuideClick = () => {
  saPushEvent(evt, {
    page_name: 'UserGuid_enter',
    page_area: 'UserGuid_page',
    button_name: 'UserGuid',
  });
}

export const newUserGuideClick = () => {
  saPushEvent(evt, {
    page_name: 'NewUserGuid_page',
    page_area: 'NewUserGuid_enter',
    button_name: 'NewUserGuid',
  });
}

export const coinClick = () => {
  saPushEvent(evt, {
    page_name: 'Coin_page',
    page_area: 'Coin_enter',
    button_name: 'Coin',
  });
}

export const buyTabClick = () => {
  saPushEvent(evt, {
    page_name: 'BuyTab_page',
    page_area: 'BuyTab_enter',
    button_name: 'BuyTab',
  });
}

export const sellTabClick = () => {
  saPushEvent(evt, {
    page_name: 'BuyTab_page',
    page_area: 'BuyTab_enter',
    button_name: 'BuyTab',
  });
}

export const filledTabClick = () => {
  saPushEvent(evt, {
    page_name: 'FilledTab_page',
    page_area: 'FilledTab_enter',
    button_name: 'FilledTab',
  });
}

export const orderbookClick = () => {
  saPushEvent(evt, {
    page_name: 'OrderBookTab_page',
    button_name: 'OrderBookTab',
  });
}

export const orderbookBuyClick = () => {
  saPushEvent(evt, {
    page_name: 'OrderBookTab_page',
    button_name: 'Buy',
  });
}

export const orderbookSellClick = () => {
  saPushEvent(evt, {
    page_name: 'OrderBookTab_page',
    button_name: 'Sell',
  });
}

export const orderHistoryClick = () => {
  saPushEvent(evt, {
    page_name: 'Orderhistroy_page',
    page_area: 'Orderhistroy_enter',
    button_name: 'Orderhistroy',
  });
}

export const feeClick = () => {
  saPushEvent(evt, {
    page_name: 'Fee_page',
    page_area: 'Fee_enter',
    button_name: 'Fee',
  });
}

export const tradingDurationClick = () => {
  saPushEvent(evt, {
    page_name: 'TradingDuration_page',
    page_area: 'TradingDuration_enter',
    button_name: 'TradingDuration',
  });
}

export const pledgeClick = () => {
  saPushEvent(evt, {
    page_name: 'PledgeRate_page',
    page_area: 'PledgeRate_enter',
    button_name: 'PledgeRate',
  });
}

export const settlementClick = () => {
  saPushEvent(evt, {
    page_name: 'SettlementTime_page',
    page_area: 'SettlementTime_enter',
    button_name: 'SettlementTime',
  });
}

export const createOrderClick = () => {
  saPushEvent(evt, {
    page_name: 'CreateOrder_page',
    page_area: 'CreateOrder_enter',
    button_name: 'CreateOrder',
  });
}

export const feeMoreClick = () => {
  saPushEvent(evt, {
    page_name: 'FeeMore_page',
    page_area: 'FeeMore_enter',
    button_name: 'FeeMore',
  });
}

export const sellClick = () => {
  saPushEvent(evt, {
    page_name: 'Sell_page',
    page_area: 'Sell_enter',
    button_name: 'Sell',
  });
}

export const buyClick = () => {
  saPushEvent(evt, {
    page_name: 'Buy_page',
    page_area: 'Buy_enter',
    button_name: 'Buy',
  });
}

export const onlyViewMyOrderClick = () => {
  saPushEvent(evt, {
    page_name: 'OnlyviewMyorder_page',
    page_area: 'OnlyviewMyorder_enter',
    button_name: 'OnlyviewMyorder',
  });
}

export const matchMyAssetClick = () => {
  saPushEvent(evt, {
    page_name: 'MathMyAssets_page',
    page_area: 'MathMyAssets_enter',
    button_name: 'MathMyAssets',
  });
}

export const myOrderClick = () => {
  saPushEvent(evt, {
    page_name: 'Myorder_page',
    page_area: 'Myorder_enter',
    button_name: 'Myorder',
  });
}

export const howBuyTakerClick = () => {
  saPushEvent(evt, {
    page_name: 'HowBuyTake_page',
    page_area: 'HowBuyTake_enter',
    button_name: 'HowBuyTake',
  });
}

export const howBuyMakerClick = () => {
  saPushEvent(evt, {
    page_name: 'HowBuyMake_page',
    page_area: 'HowBuyMake_enter',
    button_name: 'HowBuyMake',
  });
}

export const howSellTakerClick = () => {
  saPushEvent(evt, {
    page_name: 'HowSellTake_page',
    page_area: 'HowSellTake_enter',
    button_name: 'HowSellTake',
  });
}

export const howSellMakerClick = () => {
  saPushEvent(evt, {
    page_name: 'HowSellMake_page',
    page_area: 'HowSellMake_enter',
    button_name: 'HowSellMake',
  });
}

export const currentOrderClick = () => {
  saPushEvent(evt, {
    page_name: 'CurrentOrder_Page',
    page_area: 'CurrentOrder_enter',
    button_name: 'CurrentOrder',
  });
}

export const orderHistoryClick2 = () => {
  saPushEvent(evt, {
    page_name: 'OrderHistory_Page',
    page_area: 'OrderHistory_enter',
    button_name: 'OrderHistory',
  });
}

export const cancelClick = () => {
  saPushEvent(evt, {
    page_name: 'Cancel_page',
    page_area: 'Cancel_enter',
    button_name: 'Cancel',
  });
}

export const cancelAllClick = () => {
  saPushEvent(evt, {
    page_name: 'CancelALL_Page',
    page_area: 'CancelALl_enter',
    button_name: 'CancelALL',
  });
}

export const buySelectClick = () => {
  saPushEvent(evt, {
    page_name: 'BuySellect_Page',
    page_area: 'BuySellect_enter',
    button_name: 'BuySellect',
  });
}

export const sellSelectClick = () => {
  saPushEvent(evt, {
    page_name: 'SellSellect_Page',
    page_area: 'SellSellect_enter',
    button_name: 'SellSellect',
  });
}

export const buySubmitClick = () => {
  saPushEvent(evt, {
    page_name: 'BuySubmit_Page',
    page_area: 'BuySubmit_enter',
    button_name: 'BuySubmit',
  });
}

export const sellSubmitClick = () => {
  saPushEvent(evt, {
    page_name: 'SellSubmit_Page',
    page_area: 'SellSubmit_enter',
    button_name: 'SellSubmit',
  });
}

export const contactClick = () => {
  saPushEvent(evt, {
    page_name: 'Contact_Page',
    page_area: 'Contact_enter',
    button_name: 'Contact',
  });
}

export const cancelSubmitClick = () => {
  saPushEvent(evt, {
    page_name: 'CancelSubmit_Page',
    page_area: 'CancelSubmit_enter',
    button_name: 'CancelSubmit_enter',
  });
}

export const confirmSubmitClick = () => {
  saPushEvent(evt, {
    page_name: 'ConfirmSubmit_Page',
    page_area: 'ConfirmSubmit-enter',
    button_name: 'ConfirmSubmit',
  });
}

export const cancelSubmitCloseClick = () => {
  saPushEvent(evt, {
    page_name: 'CancelSubmit-close_Page',
    page_area: 'CancelSubmit-close_enter',
    button_name: 'CancelSubmit-close',
  });
}

export const AvailableCoinsClick = () => {
  saPushEvent('AvailableCoinsClick', {
    page_name: 'PreMarketSpotHomepage',
    button_name: 'AvailableCoinsClick',
  });
}

export const MyOrderClick = () => {
  saPushEvent('MyOrderClick', {
    page_name: 'PreMarketSpotHomepage',
    button_name: 'MyOrderClick',
  });
}

export const PastCoinsClick = () => {
  saPushEvent('PastCoinsClick', {
    page_name: 'PreMarketSpotHomepage',
    button_name: 'PastCoinsClick',
  });
}

export const ChartClick = () => {
  saPushEvent('ChartClick', {
    page_name: 'PreMarketSpotCoin',
    button_name: 'ChartClick',
  });
}